import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
}

// Format currency in compact form for mobile (e.g., 12.5jt instead of Rp 12.500.000)
export function formatCurrencyCompact(amount) {
  if (amount >= 1000000000) {
    return `Rp ${(amount / 1000000000).toFixed(1)}M`;
  } else if (amount >= 1000000) {
    return `Rp ${(amount / 1000000).toFixed(1)}jt`;
  } else if (amount >= 1000) {
    return `Rp ${(amount / 1000).toFixed(0)}rb`;
  }
  return formatCurrency(amount);
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}

export function formatMonth(monthString) {
  if (!monthString) return '-';
  const [year, month] = monthString.split('-');
  const date = new Date(year, parseInt(month) - 1);
  return date.toLocaleDateString('id-ID', {
    month: 'long',
    year: 'numeric'
  });
}

export function getStatusLabel(status) {
  const labels = {
    kosong: 'Kosong',
    terisi: 'Terisi',
    aktif: 'Aktif',
    nonaktif: 'Non-Aktif',
    selesai: 'Selesai',
    lunas: 'Lunas',
    belum_bayar: 'Belum Bayar',
    terlambat: 'Terlambat',
    menunggu_verifikasi: 'Menunggu Verifikasi'
  };
  return labels[status] || status;
}

export function getPaymentTypeLabel(type) {
  const labels = {
    sewa: 'Sewa Kamar',
    listrik: 'Listrik',
    air: 'Air',
    lainnya: 'Lainnya'
  };
  return labels[type] || type;
}

export function getCurrentMonth() {
  // Use local timezone (WIB for Indonesia)
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
}

export function getMonthOptions(count = 12) {
  const options = [];
  const today = new Date();
  // Start from current month and go forward (for advance payment like kost)
  for (let i = 0; i < count; i++) {
    const date = new Date(today.getFullYear(), today.getMonth() + i, 1);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const value = `${year}-${month}`;
    const label = date.toLocaleDateString('id-ID', { month: 'long', year: 'numeric' });
    options.push({ value, label });
  }
  return options;
}

// Get today's date in YYYY-MM-DD format (local timezone)
export function getTodayDate() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
